import { ButtonDS, DialogModalDS, MessageTooltip, Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SessionIdentity } from "./SessionIdentity";
import "../../../../../i18n/i18n";

export const ConfirmUpdateRestitutionModal = (props: {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  driverName: string;
  registrationNumber: string | null;
}) => {
  const { t } = useTranslation();

  return (
    <DialogModalDS
      visible={props.visible}
      deactivateClickOutsideSidePanel
      onClose={props.onClose}
      title={t("fleet.vehicleSessions.sidepanel.updateRestitutionModal.title")}
      width={40}
      bottomButtons={{
        leftButton: (
          <ButtonDS
            text={t(
              "fleet.vehicleSessions.sidepanel.confirmUpdateRestitutionModal.back",
            )}
            format={"fill"}
            buttonType={"secondary"}
            onClick={props.onClose}
          />
        ),
        rightButton: (
          <ButtonDS
            text={t(
              "fleet.vehicleSessions.sidepanel.confirmUpdateRestitutionModal.confirm",
            )}
            format={"fill"}
            buttonType={"primary"}
            onClick={props.onConfirm}
          />
        ),
      }}
    >
      <StyledColumn>
        <SessionIdentity
          driverName={props.driverName}
          registrationNumber={props.registrationNumber}
        />
        <Spacer y={1.5} />
        <MessageTooltip
          title={t(
            "fleet.vehicleSessions.sidepanel.confirmUpdateRestitutionModal.warning.title",
          )}
          type={"WARNING"}
        />
      </StyledColumn>
    </DialogModalDS>
  );
};

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
